<template>
  <footer class="navigation-footer">
    <section class="navigation-footer__container">
      <ul class="navigation-footer__list -mobile-row">
        <a href="mailto:info@mariedooley.com" class="navigation-footer__item -row -link">info@mariedooley.com</a>
        <a href="https://www.facebook.com/MarieDooleyMaison/" target="_blank" class="navigation-footer__item -row -link">Facebook</a>
        <a href="https://www.instagram.com/mariedooleymaison/" target="_blank" class="navigation-footer__item -row -link">Instagram</a>
      </ul>

      <nav class="navigation-footer__list">
        <RouterLink to="/" class="navigation-footer__item -link" exact>
          Français
        </RouterLink>

        <RouterLink to="/en" class="navigation-footer__item -link">
          English
        </RouterLink>
      </nav>
    </section>

    <div class="navigation-footer__copyright">
      <p>&copy; {{ currentYear }} Marie Dooley Acoustic. All Rights Reserved</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'NavigationFooter',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      links: [
        { name: 'home', label: 'Home' },
        { name: 'component-demo', label: 'Demo' }
      ]
    }
  }
}
</script>
